import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useDocumentTitle } from 'hooks';

export function ScrollToTop() {
	const location = useLocation();

	useDocumentTitle();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location]);

	return null;
}
